import * as tslib_1 from "tslib";
import HLabel from "../../../../../form/src/common/components/label.vue";
import { labelText } from "../../../../../form/src/schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let ModifiedTime = class ModifiedTime extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], ModifiedTime.prototype, "control", void 0);
ModifiedTime = tslib_1.__decorate([
    Component({
        name: 'ModifiedTime',
        components: {
            HLabel: HLabel
        }
    })
], ModifiedTime);
export default ModifiedTime;
